/* eslint-disable no-restricted-globals */
export const getInjectedProviderFromWindow = <T = unknown>(
  path: string
): T | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  // Traverse the path safely
  const target: unknown = path.split('.').reduce<unknown>(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, key) => (acc == null ? null : (acc as any)[key]),
    window
  );

  if (typeof target !== 'object' || target === null) {
    return null;
  }

  if (Array.isArray(target)) {
    return target.length > 0 ? (target[0] as T) : null;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const providersArray = (target as any).providers;

  if (providersArray && Array.isArray(providersArray)) {
    return providersArray.length > 0 ? (providersArray[0] as T) : null;
  }

  return target as T;
};
